import { type CategoryId, CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { usePreference, PreferenceKey } from "@/composables/usePreference";

const validate = (raw: unknown): CategoryId | null => {
  const parsed = CategoryId_Schema.safeParse(raw);
  return parsed.success ? parsed.data : null;
};

export function useRememberedCategory() {
  const preference = usePreference<CategoryId | null>(PreferenceKey.RememberedCategory, null, validate);

  function rememberCategoryId(categoryId: CategoryId): void {
    preference.value = categoryId;
  }

  return {
    rememberedCategoryId: computed(() => preference.value),
    rememberCategoryId,
  };
}
